// FacturasClienteDialog.jsx - MEJORADO
import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'
import { generarPDFFactura } from '../utils/pdfGenerator'
import { Download, Printer, X, FileText } from 'lucide-react'

export default function FacturasClienteDialog({ cliente, onClose }) {
  const [facturas, setFacturas] = useState([])
  const [loading, setLoading] = useState(true)
  const [configuracion, setConfiguracion] = useState(null)

  useEffect(() => {
    cargarFacturas()
    cargarConfiguracion()
  }, [])

  async function cargarConfiguracion() {
    const { data } = await supabase
      .from('configuracion')
      .select('*')
      .limit(1)
      .single()
    
    setConfiguracion(data)
  }

  async function cargarFacturas() {
    try {
      const { data, error } = await supabase
        .from('facturas')
        .select('*, lineas:factura_lineas(*)')
        .eq('client_id', cliente.id)
        .order('fecha_emision', { ascending: false })
      
      if (error) throw error
      
      const facturasConLineas = (data || []).map(f => ({
        ...f,
        lineas: f.lineas || []
      }))
      
      setFacturas(facturasConLineas)
    } catch (error) {
      console.error('Error:', error)
      alert('Error al cargar facturas')
    } finally {
      setLoading(false)
    }
  }

  async function descargarPDF(factura, formato = 'a4') {
    try {
      const doc = await generarPDFFactura(factura, configuracion, { formato })
      const nombreArchivo = formato === 'termica'
        ? `factura-${factura.serie}-${factura.numero}-80mm.pdf`
        : `factura-${factura.serie}-${factura.numero}.pdf`
      doc.save(nombreArchivo)
    } catch (error) {
      alert('Error generando PDF: ' + error.message)
    }
  }

  async function imprimirFactura(factura, formato = 'termica') {
    try {
      const doc = await generarPDFFactura(factura, configuracion, { formato })
      window.open(doc.output('bloburl'), '_blank')
    } catch (error) {
      alert('Error generando PDF: ' + error.message)
    }
  }

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '900px' }}>
        <div className="dialog-header">
          <h2><FileText size={24} /> Facturas de {cliente.alias}</h2>
          <button onClick={onClose} className="btn-icon">
            <X size={20} />
          </button>
        </div>

        <div className="dialog-body">
          {loading ? (
            <div style={{ padding: '2rem', textAlign: 'center' }}>
              Cargando facturas...
            </div>
          ) : facturas.length === 0 ? (
            <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--muted)' }}>
              No hay facturas para este cliente
            </div>
          ) : (
            <div className="tabla-wrapper">
              <table className="tabla-lineas">
                <thead>
                  <tr>
                    <th>Nº</th>
                    <th>Fecha</th>
                    <th>Período</th>
                    <th style={{ textAlign: 'right' }}>Total</th>
                    <th>Estado</th>
                    <th style={{ textAlign: 'center' }}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {facturas.map(factura => (
                    <tr key={factura.id}>
                      <td style={{ fontWeight: 'bold' }}>
                        {factura.serie}-{factura.numero}
                      </td>
                      <td>
                        {new Date(factura.fecha_emision).toLocaleDateString('es-ES')}
                      </td>
                      <td style={{ fontSize: '0.875rem' }}>
                        {new Date(factura.periodo_inicio).toLocaleDateString('es-ES')} - {' '}
                        {new Date(factura.periodo_fin).toLocaleDateString('es-ES')}
                      </td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                        {factura.total.toFixed(2)}€
                      </td>
                      <td>
                        {factura.estado_verifactu === 'enviada' ? (
                          <span className="badge badge-success">✓ Enviada</span>
                        ) : (
                          <span className="badge badge-warning">⏳ Pendiente</span>
                        )}
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'center' }}>
                          <button
                            onClick={() => descargarPDF(factura, 'a4')}
                            className="btn-icon"
                            title="Descargar PDF A4"
                          >
                            <Download size={16} />
                          </button>
                          <button
                            onClick={() => descargarPDF(factura, 'termica')}
                            className="btn-icon"
                            title="Descargar PDF 80mm"
                          >
                            <Download size={16} style={{ transform: 'scale(0.8)' }} />
                          </button>
                          <button
                            onClick={() => imprimirFactura(factura, 'termica')}
                            className="btn-icon"
                            title="Imprimir 80mm"
                          >
                            <Printer size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="dialog-footer">
          <button onClick={onClose} className="btn-secondary">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  )
}